import { Component } from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-services-terapia-fisica',
  standalone: true,
  imports: [
    NgOptimizedImage
  ],
  templateUrl: './services-terapia-fisica.component.html',
  styleUrl: './services-terapia-fisica.component.css'
})
export class ServicesTerapiaFisicaComponent {

}
